import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";
import { EmployeePATemplate } from "./types";

export const employeePATemplateListService = (params: {
  page?: number | null;
  limit?: number | null;
  productivityTemplateId?: string | null;
  productivityTemplateIds?: string[] | null;
  status?: number | null;
  employeeIds?: number[] | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<EmployeePATemplate>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const employeePATemplateAssignService = (data: {
  productivityTemplateId: string;
  employeeIds?: number[];
  empCodes?: string[];
  templateCode: string;
  status: number;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Assign,
    config: {
      requireAuthentication: true,
    },
    data,
  });

export const employeePATemplateAssignTemplatesService = (
  data: Types.EmployeePATemplateAssignTemplatesRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.AssignTemplates,
    config: {
      requireAuthentication: true,
    },
    data,
  });

export const employeePATemplateRemoveTemplatesService = (
  data: Types.EmployeePATemplateRemoveTemplatesRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.RemoveTemplates,
    config: {
      requireAuthentication: true,
    },
    data,
  });

export const employeePATemplateInactiveService = (params: { id: string }) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: Paths.Inactive?.replace("{id}", params?.id),
    config: {
      requireAuthentication: true,
    },
  });
export const employeePATemplateActiveService = (params: { id: string }) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: Paths.Active?.replace("{id}", params?.id),
    config: {
      requireAuthentication: true,
    },
  });
export const employeePATemplateDeleteService = (params: {
  id: string;
  templateCode: string;
  empCode: string;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.Delete?.replace("{id}", params?.id)
      ?.replace("{templateCode}", params?.templateCode)
      ?.replace("{empCode}", params?.empCode),
    config: {
      requireAuthentication: true,
    },
  });
